import React, { PropsWithChildren } from 'react';
import { Field, useFormState } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';

import {
  EmailRecipientsArray,
  FieldCheckbox,
  FieldTextInput,
  SignersArray,
} from 'Components/FormFields';
import { DocumentValues, InteractExtraValues } from 'Interfaces/Document';
import { composeValidators } from 'Utils/functions';
import { email, notOnlySpaces, required } from 'Utils/validation';

interface SelectActionFormSendPageProps {
  isChooseActionDisabled?: boolean;
  onSetExtraValues: (values: InteractExtraValues) => void;
}

const SelectActionFormSendPage = ({
  isChooseActionDisabled,
  onSetExtraValues,
  children,
}: PropsWithChildren<SelectActionFormSendPageProps>) => {
  const { values } = useFormState<DocumentValues>();

  return (
    <>
      <p className="selectActionForm__emailField-title">Choose Signers</p>
      <div className="selectActionForm__signersContainer">
        <FieldArray
          name="signers"
          render={props => (
            <SignersArray
              {...props}
              isAdditionDisabled={isChooseActionDisabled}
              isRemoveDisabled={isChooseActionDisabled}
              isOrderedDisabled={isChooseActionDisabled}
              isItemDeletablePredicate={({ fields }) =>
                !!fields.length && fields.length > 2
              }
              handleSetSignersValues={onSetExtraValues}
              renderFields={name => (
                <div className="selectActionForm__signerItem">
                  <Field
                    name={`${name}.name`}
                    placeholder="Name"
                    component={FieldTextInput}
                    validate={composeValidators<string>(required, notOnlySpaces)}
                    disabled={isChooseActionDisabled}
                  />
                  <Field
                    name={`${name}.email`}
                    placeholder="Email"
                    component={FieldTextInput}
                    validate={composeValidators<string>(required, email)}
                    disabled={isChooseActionDisabled}
                  />
                </div>
              )}
            />
          )}
          isOrdered={values.isOrdered}
        />
      </div>
      <Field
        name="isOrdered"
        label="Custom signing order"
        className="selectActionForm__emailField-isOrdered"
        render={FieldCheckbox}
        disabled={isChooseActionDisabled}
        onClick={onSetExtraValues}
      />
      <div className="selectActionForm__emailField">
        <p className="selectActionForm__emailField-title selectActionForm__emailField-title--expanded">
          Add Viewers
        </p>
        <FieldArray
          name="recipients"
          label={null}
          component={EmailRecipientsArray}
          isItemsDeletable
          handleSetRecipientsValues={onSetExtraValues}
        />
      </div>
      {children}
    </>
  );
};

export default SelectActionFormSendPage;
